import React from 'react';
import { MktFaqsAccordionTab } from './FaqsAccordionTab';

export interface tab {
  title: string;
  description: string;
}

interface MktFaqsAccordionProps {
  tabs: tab[];
}

export const MktFaqsAccordion: React.FC<MktFaqsAccordionProps> = ({ tabs }) => {
  return (
    <div className="wh-h-auto wh-flex wh-flex-col wh-gap-2 wh-w-full">
      {tabs.map((tab, i) => {
        return <MktFaqsAccordionTab key={i} {...tab} />;
      })}
    </div>
  );
};
